import styled from "styled-components";
import React, { useState, useRef, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguageContext } from "../languageContext";
import { useTranslation } from "react-i18next";

const Drawer = ({ open, setOpenDrawer, onChange, selected, history }) => {
  const dispatch = useDispatch();
  const { count } = useSelector((state) => state.alert);
  const { count_video } = useSelector((state) => state.video);

  const { userInfo } = useSelector((state) => state.userLogin);
  const myRef = useRef();
  const layerRef = useRef();
  const { t } = useLanguageContext();
  const { i18n } = useTranslation();

  const handleClickOutside = (e) => {
    if (layerRef.current) {
      if (layerRef.current.contains(e.target)) {
        setOpenDrawer(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  const handleLogout = () => {
    history.push("/dashboard/login");
    dispatch(logout());
  };
  return (
    <div>
      {open && <BackgroundLayer ref={layerRef} />}
      <Wrapper  dir={i18n.language === "ar" ? "rtl" : "ltr"} fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"] || userInfo["isQuestionManager"]}  
      open={open} ref={myRef} onClick={() => setOpenDrawer(false)}>
        <List>
          {open && (
            <Close onClick={setOpenDrawer}>
              <CloseIcon />
            </Close>
          )}
          {!userInfo["isJournalist"] && !userInfo["isAlertsManager"] && !userInfo["isVideosManager"] &&  !userInfo["isQuestionManager"] &&(
            <LinkContainer to="/dashboard/">
                <Item     
                  fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"] || userInfo["isQuestionManager"]} 
                  selected={selected === 0} onClick={() => onChange(0)}>
                <Image
                  src={
                    require(selected === 0
                      ? "../images/icon1act.svg"
                      : "../images/icon1.svg").default
                  }
                  alt=""
                />
                <Label>{t("home")}</Label>
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isJournalist"] && !userInfo["isAlertsManager"] && !userInfo["isVideosManager"] && (
            <LinkContainer to="/dashboard/questions">
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"] || userInfo["isQuestionManager"]} 
                selected={selected === 1} onClick={() => onChange(1)}>
                <Image
                  src={
                    require(selected === 1
                      ? "../images/icon4act.svg"
                      : "../images/icon4.svg").default
                  }
                  alt=""
                />
                <Label>{t("questions")}</Label>
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isJournalist"] && !userInfo["isVideosManager"] && !userInfo["isQuestionManager"] && (
            <LinkContainer to="/dashboard/alerts">
                <Item  fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"] || userInfo["isQuestionManager"]} 
                selected={selected === 2} onClick={() => onChange(2)}>
                <Image
                  src={
                    require(selected === 2
                      ? "../images/icon6act.svg"
                      : "../images/icon6.svg").default
                  }
                  alt=""
                />
                <Label>{t("alerts")}</Label>
                {count > 0 && <Number>{count > 99 ? "+99" : count}</Number>}
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isJournalist"] && !userInfo["isAlertsManager"]  && !userInfo["isQuestionManager"] && (
            <LinkContainer to="/dashboard/videos">
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]|| userInfo["isQuestionManager"]}  
                selected={selected === 11} onClick={() => onChange(11)}>
                <Image
                  src={
                    require(selected === 11
                      ? "../images/icon3act.svg"
                      : "../images/icon3.svg").default
                  }
                  alt=""
                />
                <Label>{t("videos")}</Label>
                {count_video > 0 && <Number>{count_video > 99 ? "+99" : count_video}</Number>}
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isJournalist"] && !userInfo["isAlertsManager"] && !userInfo["isVideosManager"] && (
            <LinkContainer to="/dashboard/new-question">
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]|| userInfo["isQuestionManager"]}  selected={selected === 3} onClick={() => onChange(3)}>
                <Image
                  src={
                    require(selected === 3
                      ? "../images/icon2act.svg"
                      : "../images/icon2.svg").default
                  }
                  alt=""
                />
                <Label>{t("newQ")}</Label>
              </Item>
            </LinkContainer>
          )}
          {userInfo["isAdmin"] && (
            <LinkContainer to="/dashboard/products">
                <Item  selected={selected === 4} onClick={() => onChange(4)}>
                <Image
                  src={
                    require(selected === 4
                      ? "../images/icon5act.svg"
                      : "../images/icon5.svg").default
                  }
                  alt=""
                />
                <Label>{t("newP")}</Label>
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isAlertsManager"] && !userInfo["isQuestionManager"] && <LinkContainer
            to={userInfo["isJournalist"] ? "/dashboard/" : "/dashboard/news"}
          >
              <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isQuestionManager"]}  selected={selected === 5} onClick={() => onChange(5)}>
              <Image
                src={
                  require(selected === 5
                    ? "../images/icon6act.svg"
                    : "../images/icon6.svg").default
                }
                alt=""
              />
              <Label>{t("newN")}</Label>
            </Item>
          </LinkContainer>}
          {!userInfo["isAdmin"] && (
            <LinkContainer to={"/dashboard/password"}>
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]|| userInfo["isQuestionManager"]} 
                selected={selected === 8} onClick={() => onChange(8)}>
                <Image
                  src={
                    require(selected === 8
                      ? "../images/icon9act.svg"
                      : "../images/icon9.svg").default
                  }
                  alt=""
                />
                <Label>{t("settings")}</Label>
              </Item>
            </LinkContainer>
          )}

          {userInfo["isAdmin"] && (
            <LinkContainer to="/dashboard/supervisors">
                <Item  selected={selected === 6} onClick={() => onChange(6)}>
                <Image
                  src={
                    require(selected === 6
                      ? "../images/icon9act.svg"
                      : "../images/icon9.svg").default
                  }
                  alt=""
                />
                <Label>{t("supervisors")}</Label>
              </Item>
            </LinkContainer>
          )}
          {userInfo["isAdmin"] && (
            <LinkContainer to="/dashboard/moderator">
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  selected={selected === 7} onClick={() => onChange(7)}>
                <Image
                  src={
                    require(selected === 7
                      ? "../images/icon8act.svg"
                      : "../images/icon8.svg").default
                  }
                  alt=""
                />
                <Label>{t("newS")}</Label>
              </Item>
            </LinkContainer>
          )}
          {!userInfo["isSupervisor"] && !userInfo["isJournalist"] && !userInfo["isAlertsManager"] && !userInfo["isVideosManager"] &&  !userInfo["isQuestionManager"] &&(
            <LinkContainer to="/dashboard/teams">
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]|| userInfo["isQuestionManager"]}  
                selected={selected === 10} onClick={() => onChange(10)}>
                <Image
                  src={
                    require(selected === 10
                      ? "../images/icon10act.svg"
                      : "../images/icon10.svg").default
                  }
                  alt=""
                />
                <Label>{userInfo["isAdmin"] ? t("teams") : t("teamS")}</Label>
              </Item>
            </LinkContainer>
          )}
           {userInfo["isAdmin"] && (
            <LinkContainer to={userInfo["isAlertsManager"] ? "/dashboard/" : "/dashboard/alertsManagers"}>
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  selected={selected === 12} onClick={() => onChange(12)}>
                <Image
                  src={
                    require(selected === 12
                      ? "../images/icon12act.svg"
                      : "../images/icon12.svg").default
                  }
                  alt=""
                />
                <Label>{t("alertsManagers")}</Label>
              </Item>
            </LinkContainer>
          )}
          {userInfo["isAdmin"] && (
            <LinkContainer to={userInfo["isVideosManager"] ? "/dashboard/" : "/dashboard/videosManagers"}>
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  selected={selected === 13} onClick={() => onChange(13)}>
                <Image
                  src={
                    require(selected === 13
                      ? "../images/icon13act.svg"
                      : "../images/icon13.svg").default
                  }
                  alt=""
                />
                <Label>{t("videosManagers")}</Label>
              </Item>
            </LinkContainer>
          )}
          {userInfo["isAdmin"] && (
            <LinkContainer to={userInfo["isQuestionManager"] ? "/dashboard/" : "/dashboard/questionManagers"}>
                <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  
                    selected={selected === 14} onClick={() => onChange(14)}>
                <Image
                  src={
                    require(selected === 14
                      ? "../images/icon2act.svg"
                      : "../images/icon2.svg").default
                  }
                  alt=""
                />
                <Label>{t("questionManagers")}</Label>
              </Item>
            </LinkContainer>
          )}
          {/*userInfo["isAdmin"] && (
            <LinkContainer to="/dashboard/new-team">
                <Item   fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  selected={selected === 9} onClick={() => onChange(7)}>
                <Image
                  src={
                    require(selected === 9
                      ? "../images/icon11act.svg"
                      : "../images/icon11.svg").default
                  }
                  alt=""
                />
                <Label>{t("newT")}</Label>
              </Item>
            </LinkContainer>
          )*/}
          <LinkContainer to="/dashboard/login">
              <Item fewItems={userInfo["isJournalist"] || userInfo["isAlertsManager"] || userInfo["isVideosManager"]}  style={{ marginTop: "80px" }} onClick={handleLogout}>
              <Image src={require("../images/icon7.svg").default} alt="" />
              <Label>{t("logout")}</Label>
            </Item>
          </LinkContainer>
        </List>
      </Wrapper>
    </div>
  );
};
const Wrapper = styled.div`
  grid-area: sidebar;
  width: 100%;
  height: 100%;
  background-color: white;
  padding:${(p) => (p.fewItems ? "30px 0.8vw" : "18px 0.8vw")};
  transition: right 0.5s cubic-bezier(0.82, 0.085, 0.395, 0.895);
  @media (${QUERIES.tabletAndDown}) {
    right: ${(p) => (p.dir=="rtl" ? p.open ? "0" : "-300px": "auto")};
    left: ${(p) => (p.dir=="ltr" ?p.open ? "0" : "-300px": "auto")};
    transition: ${(p) => (p.open ? "left 0.5s ease" : "left 0.4s ease-out")};
    position: absolute;
    top: -80px;
    bottom: 0;
    height: calc(100% + 80px);
    width: max-content;
    z-index: 2001;
    padding: 25px 0.8vw;
  }
`;
const Number = styled.span`
  color: white;
  background-color: ${COLORS.red};
  font-family: "Din";
  font-weight: 600;
  font-size: 10px;
  border-radius: 4px;
  min-width: 8px;
  padding: 1.2px 3.3px;
  margin-left: 10px;
  min-width: 15px;
  text-align: center;
`;
const List = styled.ul`
  list-style: none;
  text-align: start;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: start;
`;
const Item = styled.li`
  padding:${(p) => (p.fewItems ? "15px" : "8px 15px")};
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 10px;
  background-color: ${(p) => (p.selected ? COLORS.green300 : "white")};
  color: ${(p) => (p.selected ? COLORS.primary : "black")};
  border-radius: 8px;
  width: max-content;
  cursor: pointer;
  &:hover {
    background-color:rgba(238, 238, 238, 0.6);
  }
`;
const Image = styled.img`
  height: 21px;
  width: 21px;
  object-fit: fill;
`;
const Label = styled.span`
  font-family: "Din";
  font-size: 0.9rem;
  font-weight: 400;
  padding:0 15px;
  user-select: none;
`;
const Close = styled.div`
  display: none;
  @media (${QUERIES.tabletAndDown}) {
    display: revert;
    padding: 0 15px;
    margin-bottom: 35px;
    cursor: pointer;
  }
`;
const BackgroundLayer = styled.div`
  display: none;
  @media (${QUERIES.tabletAndDown}) {
    display: revert;
    background-color: rgba(0, 0, 0, 0.27);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2000;
    top: 0;
    left: 0;
  }
`;

export default Drawer;
